module.exports = __webpack_public_path__ + "openai-logo-8c18c447a7c3626b812266b00e6c8d6a.png";